//export const endpoint = 'https://mihorario.uninorte.edu.co/M1H0R4R10';
//export const endpoint = 'https://pomeloqa.uninorte.edu.co/M1H0R4R10';
//export const endpoint = 'https://tananeoqa.uninorte.edu.co/M1H0R4R10';

export let endpoint =  'https://mihorario.uninorte.edu.co/M1H0R4R10'; //'http://localhost:3052/M1H0R4R10';
export const urlbase = '/mihorario'; 

if (process.env.REACT_APP_HORUM_ENV === 'PROD') {
    endpoint = 'https://mihorario.uninorte.edu.co/M1H0R4R10';
}
if (process.env.REACT_APP_HORUM_ENV === 'DEV') {
    endpoint = 'https://pomeloqa.uninorte.edu.co/M1H0R4R10';
}
